import ViewerSocialProfile from 'models/user/ViewerSocialProfile';
import ViewerPulseOxEnable from 'models/user/ViewerPulseOxEnable';
import UserBiometrics from 'models/user/ViewerUserBiometrics';
import RoleUtil from 'utils/RoleUtil';
import DateFormatter from 'utils/date/DateFormatter';
import { ecgRoute, jetLagRoute, bodyBatteryRoute, garminTrailsRoute } from 'routes/obfuscatedRoutes';
import { isChinaUser } from 'utils/ChinaUtil';
import { isAccountSharingReadonlyMode, isReadonlyMode } from 'system/SystemUtil';
import { BPPageRoute } from 'BloodPressure/BloodPressureConstant';
import { garminTrailsHash } from '../../../services/omt/subscription/subscriptionFields';
import TrainingStatusUtil from 'utils/TrainingStatusUtil';

export default {
    getMenuJson: function(
        serviceHost,
        preferences,
        viewerAgentDevices,
        internalAppsHost,
        isGarminTrailsEnabled,
        mfp,
        isUserSubscribedToGCP,
        advancedReporting,
        usageIndicators,
        showTolerance,
        showEconomy
    ) {
        let today = DateFormatter.formatISODate(new Date());
        var menuJson = {
            dashboards: [],
            main: [],
            social: [],
            other: []
        };

        var fitnessUser = ViewerSocialProfile.isFitnessUser(),
            wellnessUser = ViewerSocialProfile.isWellnessUser(),
            outdoorUser = ViewerSocialProfile.isOutdoorUser(),
            diveUser = ViewerSocialProfile.isDiveUser(),
            marineUser = ViewerSocialProfile.isMarineUser(),
            raceEventProvider = ViewerSocialProfile.isRaceEventProvider();

        if (!preferences) {
            preferences = {};
        }

        menuJson.dashboards.push({
            title: 'main_header_home_text',
            icon: 'icon-home',
            url: `/home`
        });

        if (raceEventProvider) {
            menuJson.dashboards.push({
                title: 'title_calendar_widget',
                icon: 'icon-calendar',
                url: '/calendar'
            });
            menuJson.main.push(
                {
                    title: 'events_menu_item_nav',
                    url: '/event-dashboard'
                },
                {
                    title: 'course_widget_title',
                    url: '/courses',
                    disabled: isAccountSharingReadonlyMode()
                }
            );
            return menuJson;
        }

        // For wellness users, this needs to be handled in a new way since Daily Summary is removed post-GC5
        // if (wellnessUser) {
        //     menuJson.dashboards.push({
        //         title: 'menu_step_summary_large', // daily summary
        //         icon: 'icon-layers',
        //         url: '/daily-summary/' + today,
        //         urlKeyword: 'timeline'
        //     });
        // }

        if (fitnessUser || wellnessUser || diveUser) {
            menuJson.dashboards.push({
                title: 'challenges',
                icon: 'icon-challenges',
                url: '/challenge',
                urlKeyword: 'challenge/',
                disabled: isAccountSharingReadonlyMode()
            });
        }

        if (fitnessUser || wellnessUser || diveUser) {
            menuJson.dashboards.push({
                title: 'title_calendar_widget',
                icon: 'icon-calendar',
                url: '/calendar'
            });
        }

        if (fitnessUser || wellnessUser || outdoorUser || diveUser) {
            menuJson.dashboards.push({
                title: 'news_feed',
                icon: 'icon-newsfeed',
                url: '/newsfeed',
                disabled: isAccountSharingReadonlyMode()
            });
        }

        if (RoleUtil.isDiveUserOnly()) {
            menuJson.main.push({
                title: 'title_diving_widget',
                icon: 'icon-activity-diving',
                url: '/diving'
            });
        }

        if (wellnessUser) {
            const activitiesMenuItems = [
                {
                    title: 'activity_type_all',
                    url: '/activities'
                },
                {
                    title: 'label_floors_climbed_unit',
                    url: '/floors',
                    urlKeyword: 'floors'
                },
                {
                    title: 'intensity_minutes',
                    url: '/intensity-minutes',
                    urlKeyword: 'intensity-minutes'
                }
            ];

            if (preferences.hideFloorFeature) {
                const floorsIndex = activitiesMenuItems.findIndex((item) => item.urlKeyword === 'floors');
                activitiesMenuItems.splice(floorsIndex, 1);
            }

            if (preferences.showSteps) {
                activitiesMenuItems.splice(1, 0, {
                    title: 'activity_type_steps',
                    url: '/steps',
                    urlKeyword: 'steps'
                });
            }

            if (preferences.showWheelchairPushes) {
                activitiesMenuItems.splice(1, 0, {
                    title: 'activity_type_wheelchair_pushes',
                    url: '/pushes',
                    urlKeyword: 'pushes'
                });
            }

            menuJson.main.push({
                title: 'activities',
                icon: preferences.isWheelchairMode ? 'icon-activities-wheelchair' : 'icon-activities',
                menuItems: activitiesMenuItems
            });
        } else if (fitnessUser || diveUser) {
            menuJson.main.push({
                title: 'activities',
                icon: preferences.isWheelchairMode ? 'icon-activities-wheelchair' : 'icon-activities',
                url: '/activities'
            });
        }

        if (fitnessUser || wellnessUser || diveUser) {
            var menuItems = [];
            if (wellnessUser) {
                menuItems.push({
                    title: 'sleep',
                    url: `/sleep/` + today,
                    urlKeyword: 'sleep'
                });
            }
            if (fitnessUser || wellnessUser || diveUser) {
                menuItems.push({
                    title: 'weight',
                    url: '/weight',
                    urlKeyword: 'weight'
                });
            }
            if (fitnessUser || wellnessUser || diveUser) {
                menuItems.push({
                    title: 'blood_pressure',
                    url: BPPageRoute,
                    urlKeyword: 'pressure'
                });
            }
            if (preferences.showHydration) {
                menuItems.push({
                    title: 'label_hydration',
                    url: `/hydration/${today}/0`,
                    urlKeyword: 'hydration'
                });
            }
            if ((fitnessUser || wellnessUser || diveUser) && preferences['hasCaloriesAvailablePref'] === 'true') {
                const isMfpConnected = mfp.get('linkStatus') === 1;
                if (isMfpConnected) {
                    menuItems.push({
                        title: 'title_calories_widget',
                        url: '/calories/' + today,
                        urlKeyword: 'calories'
                    });
                } else {
                    menuItems.push({
                        title: 'title_calories_no_mfp_widget',
                        url: '/calories/' + today,
                        urlKeyword: 'calories'
                    });
                }
            }
            if (
                preferences.showAllDayPulseOx &&
                (ViewerPulseOxEnable.get('capableEnable') === true || UserBiometrics.get('locale') === 'ja') &&
                preferences['hasPulseOxAllDayCapableDevice']
            ) {
                menuItems.push({
                    title: 'pulse_ox',
                    url: '/pulse-ox/' + today
                });
            }

            var pulseOxAcclimationItem = {
                title: 'title_pulse_ox_acclimation_widget',
                url: '/pulse-ox-acclimation'
            };

            if (
                preferences['hasPulseOxAllDayCapableDevice'] &&
                (ViewerPulseOxEnable.get('capableEnable') === true || UserBiometrics.get('locale') === 'ja')
            ) {
                menuItems.push(pulseOxAcclimationItem);
            }

            if (preferences.showRespiration && preferences['hasRespirationCapableDevice']) {
                menuItems.push({
                    title: 'label_respiration',
                    url: '/respiration/' + today,
                    urlKeyword: 'respiration'
                });
            }

            if (wellnessUser) {
                menuItems.push({
                    title: 'label_heart_rate',
                    url: '/heart-rate/' + today,
                    urlKeyword: 'heart-rate'
                });
            }

            if (preferences['hasFitnessAgeV2CapableDevice']) {
                menuItems.push({
                    title: 'fitness_age',
                    url: '/fitness-age',
                    urlKeyword: 'fitness-age'
                });
            }

            if (wellnessUser) {
                menuItems.push({
                    title: 'title_stress_widget',
                    url: `/stress/${today}/0`,
                    urlKeyword: 'stress'
                });
            }
            if (wellnessUser && preferences['hasBodyBatteryCapableDevice']) {
                menuItems.push({
                    title: 'body_battery',
                    url: `/${bodyBatteryRoute}`,
                    urlKeyword: 'body-battery'
                });
            }
            if (preferences.showMenstrualCycleTracking) {
                menuItems.push({
                    title: 'label_menstrual_cycle',
                    url: '/menstrual-cycle-tracking/' + today
                });
            }
            if (preferences.showPregnancy) {
                menuItems.push({
                    title: 'label_pregnancy',
                    url: '/pregnancy-detail/' + today
                });
            }

            if (preferences.showECG) {
                menuItems.push({
                    title: 'ecg',
                    url: `/${ecgRoute}`,
                    disabled: isReadonlyMode()
                });
            }

            if (preferences.showHealthSnapshot) {
                menuItems.push({
                    title: 'health_snapshot',
                    url: '/health-snapshots'
                });
            }

            menuJson.main.push({
                title: 'health_stats',
                icon: 'icon-heart',
                menuItems: menuItems
            });
        }

        // Performance Nav
        let performanceItems = [];
        if (TrainingStatusUtil.isTrainingStatusAvailable(usageIndicators)) {
            performanceItems.push({
                title: 'training_status_nav',
                icon: '',
                url: '/report/-1/all/current'
            });
        }

        if (usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasTrainingReadinessCapableDevice')) {
            let dateObj = new Date();

            performanceItems.push({
                title: 'training_readiness_nav',
                icon: '',
                url: '/training-readiness/' + dateObj.toISOString().substring(0, 10)
            });
        }

        if (usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasHrvStatusCapableDevice')) {
            performanceItems.push({
                title: 'hrv_status_nav',
                icon: '',
                url: '/hrv-status'
            });
        }

        if (usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasRacePredictionsRunCapableDevice')) {
            performanceItems.push({
                title: 'race_predictor_nav',
                icon: '',
                url: '/report/-29/running/current'
            });
        }

        if (
            usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasVO2MaxRunCapable') ||
            usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasVO2MaxBikeCapable')
        ) {
            performanceItems.push({
                title: 'vo2_max_nav',
                icon: '',
                url: '/report/21/all/current'
            });
        }

        // Cleanup ticket: CA-193107, remove showEconomy and keep device indicator check
        if (
            usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasRunningEconomyCapableDevice') &&
            showEconomy
        ) {
            performanceItems.push({
                title: 'RUNNING_ECONOMY',
                icon: '',
                url: '/report/-49/running/current'
            });
        }

        if (
            usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasAerobicTrainingEffectCapableDevice') ||
            usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasAnaerobicTrainingEffectCapableDevice')
        ) {
            performanceItems.push({
                title: 'label_training_effect',
                icon: '',
                url: '/report/62/running/last_seven_days'
            });
        }

        if (usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasPowerCurveCapableDevice')) {
            performanceItems.push({
                title: 'power_curve_title',
                icon: '',
                url: '/report/-6/cycling/last_four_weeks'
            });
        }

        if (usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasFTPCapable')) {
            performanceItems.push({
                title: 'ftp',
                icon: '',
                url: '/report/50/all/current'
            });
        }

        if (usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasCriticalSwimSpeedCapableDevice')) {
            performanceItems.push({
                title: 'critical_swim_speed_nav',
                icon: '',
                url: '/report/-37/swimming/current'
            });
        }

        // Cleanup ticket: CA-185063, remove showTolerance and keep device indicator check
        if (
            usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasRunningToleranceCapableDevice') &&
            showTolerance
        ) {
            performanceItems.push({
                title: 'RUNNING_TOLERANCE',
                icon: '',
                url: '/report/-46/running/current'
            });
        }

        if (usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasRunningLactateThresholdCapableDevice')) {
            performanceItems.push({
                title: 'lactate_threshold_label',
                icon: '',
                url: '/report/-39/running/current'
            });
        }

        if (usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasHillScoreAndEnduranceScoreCapableDevice')) {
            performanceItems.push(
                {
                    title: 'endurance_score_nav',
                    icon: '',
                    url: '/report/-41/all/current'
                },
                {
                    title: 'hill_score_nav',
                    icon: '',
                    url: '/report/-40/running/last_one_day'
                }
            );
        }

        if (usageIndicators.hasCurrentOrHistoricalIndicator('device', 'hasHRVStressCapableDevice')) {
            performanceItems.push({
                title: 'hrv_stress_nav',
                icon: '',
                url: '/report/65/all/last_seven_days'
            });
        }

        if (performanceItems.length > 0) {
            menuJson.main.push({
                title: 'performance_stats_nav',
                uiIcon: 'ChartsBar',
                menuItems: performanceItems
            });
        }

        if (outdoorUser) {
            var menuItems = [
                {
                    title: 'scorecards',
                    url: '/my-scorecards',
                    urlKeyword: 'scorecard',
                    disabled: isAccountSharingReadonlyMode()
                },
                {
                    title: 'title_golf_stats_widget',
                    url: '/golf-stats',
                    urlKeyword: 'golf-stat'
                },
                {
                    title: 'title_golf_course_widget',
                    url: '/my-golf-courses',
                    urlKeyword: 'golf-course'
                },
                {
                    title: 'title_golf_leaderboard_widget',
                    url: '/golf-leaderboards',
                    urlKeyword: 'golf-leaderboard',
                    disabled: isAccountSharingReadonlyMode()
                }
            ];

            menuJson.main.push({
                title: 'golf',
                icon: preferences.isWheelchairMode ? 'icon-activity-golf-wheelchair' : 'icon-activity-golf',
                menuItems: menuItems
            });
        }

        if (fitnessUser || diveUser) {
            var menuItems = [
                {
                    title: 'workouts',
                    url: '/workouts',
                    urlKeyword: 'workout'
                },
                {
                    title: preferences.dswEnabled ? 'training_menu_item_nav' : 'label_training_plans', // Clean up ticket: CA-161362
                    url: '/training-plan'
                },
                {
                    title: 'events_menu_item_nav',
                    url: '/event-dashboard'
                },
                {
                    title: 'course_widget_title',
                    url: '/courses',
                    disabled: isAccountSharingReadonlyMode()
                },
                {
                    title: 'pacepro_menu_item_nav',
                    url: '/pacepro'
                }
            ];

            if (preferences['hasPowerGuidanceCapableDevice']) {
                menuItems.push({
                    title: 'power_guidance_menu_item_nav',
                    url: '/power-guidance'
                });
            }

            menuItems.push({
                title: 'segments',
                url: '/segments',
                disabled: isAccountSharingReadonlyMode()
            });

            if (isGarminTrailsEnabled && !isChinaUser()) {
                menuItems.push({
                    title: garminTrailsHash,
                    url: `/${garminTrailsRoute}`,
                    disabled: isAccountSharingReadonlyMode()
                });
            }

            // remove popularity-heatmap item for CN
            if (!isChinaUser()) {
                menuItems.push({
                    title: 'course_map_label_popularity_heatmap',
                    url: '/popularity-heatmap'
                });
            }

            if (preferences.showJetLag) {
                menuItems.push({
                    title: 'jet_lag_advisor',
                    url: `/${jetLagRoute}/manage-trips`
                });
            }

            menuJson.main.push({
                title: 'training_and_planning',
                icon: 'icon-workouts',
                menuItems: menuItems
            });
        } else if (wellnessUser) {
            const menuItems = [
                {
                    title: 'queue.workout',
                    url: '/workouts',
                    urlKeyword: 'workout'
                }
            ];

            if (preferences.showJetLag) {
                menuItems.push({
                    title: 'jet_lag_advisor',
                    url: `/${jetLagRoute}/manage-trips`
                });
            }

            menuJson.main.push({
                title: 'training_and_planning',
                icon: 'icon-workouts',
                menuItems
            });
        }

        if (diveUser && !RoleUtil.isDiveUserOnly()) {
            menuJson.main.push({
                title: 'title_diving_widget',
                icon: 'icon-activity-diving',
                url: '/diving'
            });
        }

        if (fitnessUser || outdoorUser || wellnessUser || diveUser) {
            menuJson.main.push({
                title: 'label_gear',
                icon: 'icon-steps',
                url: '/gear'
            });
        }

        if (wellnessUser && preferences.showInsights) {
            menuJson.main.push({
                title: 'title_insights_widget',
                icon: 'icon-insights',
                url: '/insights'
            });
        }

        if (fitnessUser || wellnessUser || diveUser) {
            menuJson.main.push({
                title: 'title_reports_widget',
                icon: 'icon-reports-bar',
                url: '/report'
            });
        }

        // Only show the advanced dashboard on the menu if the user has an active subscription
        if (isUserSubscribedToGCP) {
            let subMenus = [];

            advancedReporting.advancedSubMenus.forEach((item, count) => {
                subMenus.push({
                    title: item.name,
                    url: `/performance-dashboard/${item.dashboardId}`,
                    urlKeyword: `${item.dashboardId}`,
                    label: item.name
                });
            });
            // Add action item to add a new dashboard if there user hasn't currently reached the limit
            if (advancedReporting.advancedSubMenus.length < advancedReporting.dashboardsLimit) {
                subMenus.push({
                    title: 'add_dashboard',
                    url: '/performance-dashboard',
                    urlKeyword: `advanced-edit`,
                    isActionItem: true
                });
            }

            menuJson.main.push({
                title: 'main_page_title',
                icon: 'icon-charts-dashboard',
                menuItems: subMenus
            });
        }

        if (fitnessUser || outdoorUser || wellnessUser || diveUser) {
            menuJson.social.push({
                title: 'connections',
                icon: 'icon-people-2',
                url: '/connections/connections',
                urlKeyword: 'search',
                disabled: isAccountSharingReadonlyMode()
            });
        }

        if (fitnessUser || outdoorUser || wellnessUser || diveUser) {
            menuJson.social.push({
                title: 'title_groups_widget',
                icon: 'icon-people-3',
                url: '/groups',
                urlKeyword: 'group/',
                disabled: isAccountSharingReadonlyMode()
            });
        }

        //badges menu will be showed for all user roles
        if (fitnessUser || outdoorUser || wellnessUser || diveUser || marineUser) {
            menuJson.other.push({
                title: 'trophy_case_badges_heading',
                icon: 'icon-badges-new',
                url: '/badges',
                disabled: isAccountSharingReadonlyMode()
            });
        }

        if (fitnessUser || wellnessUser || diveUser) {
            menuJson.other.push(
                {
                    title: 'personal_records',
                    icon: 'icon-personal-records',
                    url: '/personal-records'
                },
                {
                    title: 'goals',
                    icon: 'icon-goals',
                    url: '/goals',
                    urlKeyword: 'goal'
                }
            );
        }

        return menuJson;
    }
};
